import { __assign } from '../../_virtual/_tslib.js';
import Vue from 'vue';
import __vue_component__ from '../icons/Icon.vue.js';
import { capitalize } from '../../node_modules/@superbet-group/web.lib.utilities/dist/index.esm.js';

var script = Vue.extend({
    name: 'AutoCompleteInput',
    props: {
        value: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        minCharacters: {
            type: Number,
            default: 0,
        },
        maxCharacters: {
            type: Number,
            default: 32,
        },
        suggestions: {
            type: Array,
            default: function () { return []; },
        },
        isAsync: {
            type: Boolean,
            default: false,
        },
        areSuggestionsShown: {
            type: Boolean,
            default: false,
        },
        isIconRight: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            arrowCounter: -1,
            isLoading: false,
        };
    },
    watch: {
        suggestions: function () {
            if (this.isAsync) {
                this.setAreSuggestionsShown(true);
                this.isLoading = false;
            }
        },
    },
    computed: {
        scrollOffset: function () {
            // Scrolling starts after 5th element
            return {
                'margin-top': "".concat(this.arrowCounter >= 4 ? -(this.arrowCounter - 4) * 44 : 4, "px"),
            };
        },
        searchTerm: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue);
            },
        },
        listeners: function () {
            var _this = this;
            return __assign(__assign({}, this.$listeners), { input: function (event) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    _this.searchTerm = event.target.value.slice(0, _this.maxCharacters);
                    // workaround for https://github.com/vuejs/vue/issues/7042
                    _this.onChange();
                } });
        },
    },
    methods: {
        capitalize: capitalize,
        setAreSuggestionsShown: function (value) {
            this.$emit('suggestionsStateChange', value);
        },
        closeSuggestions: function () {
            this.setAreSuggestionsShown(false);
            this.arrowCounter = -1;
        },
        chooseSuggestion: function (suggestion) {
            this.searchTerm = typeof suggestion === 'string' ? suggestion : suggestion.label;
            this.setAreSuggestionsShown(false);
            this.$emit('itemClick', suggestion);
        },
        onChange: function () {
            if (this.value.trim().length >= this.minCharacters) {
                if (this.isAsync) {
                    this.isLoading = true;
                }
                else {
                    this.setAreSuggestionsShown(true);
                }
            }
        },
        onArrowDown: function () {
            if (this.arrowCounter < this.suggestions.length - 1) {
                this.arrowCounter = (this.arrowCounter + 1);
            }
        },
        onArrowUp: function () {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter: function (event) {
            if (this.arrowCounter !== -1) {
                this.chooseSuggestion(this.suggestions[this.arrowCounter]);
                event.preventDefault();
            }
        },
        handleClickOutside: function (event) {
            if (!this.$el.contains(event.target)) {
                this.closeSuggestions();
            }
        },
    },
    mounted: function () {
        document.addEventListener('click', this.handleClickOutside);
        if (this.autofocus) {
            var inputRef = this.$refs['inputRef'];
            inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
        }
    },
    destroyed: function () {
        document.removeEventListener('click', this.handleClickOutside);
    },
    components: {
        Icon: __vue_component__,
    },
});

export default script;
